module.exports = __webpack_public_path__ + "static/media/PSSPCategory.d67edaf4.pdf";